const checkoutAccordionStr = 'checkout-accordion';
const checkoutAccordionCls = '.checkout-accordion';
const checkoutCurrentAccordion = `${checkoutAccordionCls}--current`;
const checkoutExpandedAccordion = `${checkoutAccordionStr}--expanded`;
const checkoutCollapsedAccordion = `${checkoutAccordionStr}--collapsed`;
const checkoutAccordionIcon = '.checkout-accordian__icon';
const checkoutLeftPanel = '.checkout-left';
const checkoutStepBody = '.step-body';
const checkoutStepBodyCollapse = '.collapse';
const minMaxLabel = '.max-min-label';
const maxLabelText = 'Maximize icon';
const minLabelText = 'Minimize icon';
const checkoutMain = {
  toggleAccordionParentClasses() {
    const thisObj = $(this);
    const checkoutAccordionStatus = thisObj.siblings(checkoutCurrentAccordion);

    const accordionExpanded = checkoutAccordionStatus.hasClass(
      checkoutExpandedAccordion
    );
    const accordionCollapsed = checkoutAccordionStatus.hasClass(
      checkoutCollapsedAccordion
    );
    const accordionImage = checkoutAccordionStatus.find(checkoutAccordionIcon);
    if (accordionExpanded) {
      checkoutAccordionStatus.removeClass(checkoutExpandedAccordion);
      checkoutAccordionStatus.addClass(checkoutCollapsedAccordion);
      accordionImage.addClass(
        'svg-icon_circle_plus_blue svg-icon_circle_plus_blue-dims'
      );
      accordionImage.removeClass(
        'svg-icon_circle_minus_blue svg-icon_circle_minus_blue-dims'
      );
      accordionImage.next(minMaxLabel).text(maxLabelText);
      checkoutMain.toggleSpans();
    }
    if (accordionCollapsed) {
      checkoutAccordionStatus.removeClass(checkoutCollapsedAccordion);
      checkoutAccordionStatus.addClass(checkoutExpandedAccordion);
      accordionImage.addClass(
        'svg-icon_circle_minus_blue svg-icon_circle_minus_blue-dims'
      );
      accordionImage.removeClass(
        'svg-icon_circle_plus_blue svg-icon_circle_plus_blue-dims'
      );
      accordionImage.next(minMaxLabel).text(minLabelText);
      checkoutMain.toggleSpans();
    }
  },
  toggleSpans() {
    let $accordianList = $(
      '.page-multiStepCheckoutSummaryPage .checkoutPageList'
    );
    $accordianList.each(function() {
      let $iconSpan = $(this).find('.checkout-accordian__icon');
      let $srSpan = $(this).find('.sr-only');
      if (window.innerWidth <= 767) {
        let iconAriaLabel = $iconSpan.attr('aria-label');
        let srSpanText = $srSpan.text();
        $iconSpan.attr('aria-hidden', 'true');
        $srSpan.attr('aria-hidden', 'true');
        $iconSpan
          .parent('.checkoutPageList')
          .attr('aria-label', iconAriaLabel + ' ' + srSpanText);
      } else {
        if ($iconSpan.attr('aria-hidden') === 'true') {
          $iconSpan.removeAttr('aria-hidden');
          $srSpan.removeAttr('aria-hidden');
          $iconSpan.parent('.checkoutPageList').removeAttr('aria-label');
        }
      }
    });
  },
  scrollIfExpandedAccordion() {
    const expandedAccordion = $(
      `${checkoutCurrentAccordion}.${checkoutExpandedAccordion}`
    );
    if ($(expandedAccordion).length > 0) {
      const sectionTop = $(expandedAccordion).offset().top;
      $('html, body').animate(
        {
          scrollTop: sectionTop - 110
        },
        500,
        'swing'
      );
    }
  },
  init() {
    this.toggleSpans();
    this.scrollIfExpandedAccordion();
    $(window).on('resize', this.toggleSpans);
    $(`${checkoutLeftPanel} ${checkoutStepBody}${checkoutStepBodyCollapse}`).on(
      'show.bs.collapse hide.bs.collapse',
      this.toggleAccordionParentClasses
    );
     if ($('#accountInactive').val() === 'true') {
      $('.checkout-container').parent().addClass('hidden');
    }
  }
};
checkoutMain.init();
